<style>
/*
@import url(https://fonts.googleapis.com/css?family=IBM+Plex+Sans:400,700,400i,700i&subset=cyrillic,cyrillic-ext,latin-ext,vietnamese);


GERAL ------------------------------------------------------------------------------------------------*/

* {
  /**
	-webkit-font-smoothing: antialiased;
	-webkit-text-size-adjust: 100%;
	box-sizing: border-box;
	color: #000;
	font-family: 'IBM Plex Sans', "Helvetica Neue", Arial, sans-serif;
	font-feature-settings: case, ss01;
	font-size: 1em;**/
}

.hover-pointer {
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.nav-list .nav-logo {
  padding: 10px;
  height: 60px;
  max-width: 15px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

.cls-1 {
  fill: #fff;
}

.ytpLyhyh_0 {
  stroke-dasharray: 933 935;
  stroke-dashoffset: 934;
  animation: ytpLyhyh_draw 1200ms ease-in-out 0ms forwards;
}

.ytpLyhyh_1 {
  stroke-dasharray: 891 893;
  stroke-dashoffset: 892;
  animation: ytpLyhyh_draw 1200ms ease-in-out 600ms forwards;
}

@keyframes ytpLyhyh_draw {
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes ytpLyhyh_fade {
  0% {
    stroke-opacity: 1;
  }
  93.33333333333333% {
    stroke-opacity: 1;
  }
  100% {
    stroke-opacity: 0;
  }
}

#app {
  /**  font-family: 'Avenir', Helvetica, Arial, sans-serif;**/
  /**font-family: "Colfax Regular";**/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
  padding: 0px;
  min-height: 100%;
}

/**
a, a:hover, a:active {
  color: #fff;
}**/

.aligner {
  display: flex;
  align-items: center;
  justify-content: center;
}

.aligner-item {
  max-width: 50%;
}

.aligner-item--top {
  align-self: flex-start;
}

.aligner-item--bottom {
  align-self: flex-end;
}

div.div100 {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

.cl-effect-3 a {
  padding: 8px 0;
}

nav a {
  position: relative;
  display: inline-block;
  margin: 2px 25px;
  outline: none;
  text-decoration: none;
  color: #fff;
  letter-spacing: 1px;
  font-weight: 400;
  text-shadow: 0 0 1px rgba(255, 255, 255, 0.3);
  font-size: 1.35em;
}

a {
  text-decoration: none;
}

nav a.logo-link {
  margin: 10px 0 0 -20px;
}

.cl-effect-13 a {
  -webkit-transition: color 0.3s;
  -moz-transition: color 0.3s;
  transition: color 0.3s;
}

.cl-effect-13 a::before {
  position: absolute;
  top: 100%;
  left: 50%;
  color: transparent;
  content: ".";
  text-shadow: 0 0 transparent;
  font-size: 1.2em;
  -webkit-transition: text-shadow 0.3s, color 0.3s;
  -moz-transition: text-shadow 0.3s, color 0.3s;
  transition: text-shadow 0.3s, color 0.3s;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  transform: translateX(-50%);
  pointer-events: none;
}

.cl-effect-13 a:hover::before,
.cl-effect-13 a:focus::before,
.cl-effect-13 a:active::before {
  color: #1867c0;
  text-shadow: 10px 0 #1867c0, -10px 0 #1867c0;
}

.cl-effect-13 a:hover,
.cl-effect-13 a:focus,
.cl-effect-13 a:active {
  color: #ba7700;
}
</style>

<template>
  <div>
    <v-toolbar dark color="primary" data-app>
      <v-toolbar-title data-app>
        <router-link :to="{ name: 'projects-home' }" class="logo-link">
          <img alt="Taybull Logo" width="200" src="../assets/logo-white.svg" />
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!--
    <v-btn icon>
      <v-icon>search</v-icon>
    </v-btn>
    <v-btn icon>
      <v-icon>apps</v-icon>
    </v-btn>
    <v-btn icon>
      <v-icon>refresh</v-icon>
    </v-btn>
    <v-btn icon>
      <v-icon>more_vert</v-icon>
    </v-btn>

    <v-avatar color="primary">
      <v-icon dark>account_circle</v-icon>
    </v-avatar>
-->
      <router-link :to="{ name: 'projects-home' }"> Projects</router-link>
      <v-menu offset-y>
        <v-toolbar-title slot="activator">
          <v-btn dark icon>
            <v-icon>account_circle</v-icon>
          </v-btn>
        </v-toolbar-title>

        <v-list>
          <v-list-tile @click="" v-if="user.fullname">
            <v-list-tile-title>
              {{ user.fullname }}
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile :to="{ name: 'projects' }">
            <v-list-tile-title>
              <span> Projects </span>
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-title> Billing & Plan </v-list-tile-title>
          </v-list-tile>
          <v-list-tile :to="{ name: 'signin' }">
            <v-list-tile-title>
              <span> Sign out </span>
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <div id="app">
      <!--
    <div id="nav" style="{padding: 10px}">
    <a href="/" class="nav-logo">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350.08 265.59" width="60"  style="margin: 10px; display: block;"><defs></defs><title>Asset 1</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path stroke="#09f" stroke-width="20" stroke-linecap="round" stroke-linejoin="round" class="cls-1 ytpLyhyh_0" d="M50.69,125.45l45.12,0Q94.76,171.25,97,217a9.82,9.82,0,0,0,1,4.5c2.42,4.16,9.42,4,13.53,4.11,6,.18,12-.32,18-.3,8.11,0,16.23,0,24.34,0h47.05c7.45,0,14.91-.25,22.36-.06,7.7.19,15.46.61,23.12-.53,2.59-.39,5.47-1.17,6.71-3.47a9.15,9.15,0,0,0,.8-3.92c.42-7.84.92-15.66.92-23.52-.08-42.31-.06-25.63-.06-68,4-.77,31.42-1,46-.36v4.85c0,25.68-.27,51.38-.46,77.07-.07,9-.14,18.06-2.37,26.75A39.87,39.87,0,0,1,278,259.71c-13,6.84-28.46,5.92-42.74,5.74-13.15-.16-26.3-.14-39.46-.11-21.28,0-42.57.14-63.84-.14-13-.16-25.92.66-38.86-.34a64.82,64.82,0,0,1-16.48-3.06c-23.64-8.31-26.5-34.52-26.4-56.13C50.35,178.9,50.69,152.23,50.69,125.45Z"></path><path stroke="#09f" stroke-width="20" stroke-linecap="round" stroke-linejoin="round" class="cls-1 ytpLyhyh_1" d="M350.05,34.16c.05-2.53,0-5.07,0-7.6L304.06,0c.35.2,0,4.18,0,4.76v9.77c0,1.41,0,2.82,0,4.24v.05c0-.43,0-.86,0-1.29.09,5.1-.1,10.2,0,15.3,0,1.28.1,2.56.09,3.84a11.24,11.24,0,0,1-1.54,6.14c-1.56,2.34-4.38,3.56-7.16,4-4.38.7-9,.36-13.43.36H66.47l-9.07,0c-2.9,0-6.82-.64-9.09-2.62a7.81,7.81,0,0,1-2.18-3.53A24.17,24.17,0,0,1,45,33.8c0-15.4,0-17.33,0-16.22V.25L.06,19.92C0,24.6,0,29.28,0,34c0,4.34,0,8.69.37,13A53.71,53.71,0,0,0,3.09,59.37a49.82,49.82,0,0,0,4,8.74c2.77,5.31,7.2,9,12.11,12a46.72,46.72,0,0,0,25.07,7c50.48.13,201,.09,251.45,0,5.86,0,11.75.63,17.6-.86,2.26-.57,4.6-1,6.81-1.71a42,42,0,0,0,19.75-12.66C347.92,62.63,349.31,48.82,350,37,350,36.08,350,35.12,350.05,34.16Z"></path></g></g></svg>

    </a>

      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> |
      <router-link to="/drag-drop">Drag Drop</router-link> |
      <router-link to="/builder">Builder</router-link>

    </div>
  -->
      <router-view />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const {
  mapState,
  mapActions,
  mapGetters,
  mapMutations,
} = createNamespacedHelpers("users");
export default {
  computed: {
    ...mapState(["user"]),
  },
};
</script>
